import { ButtonLink, WarningAlert } from "@naf/teamscheme";
import styled from "styled-components";
import type { ReportPreviewClient } from "../../../report/ReportPreview";

const Wrapper = styled.div`
  margin: 0 0 ${({ theme }) => theme.spacing.space24} 0;
`;

export interface OutdatedPreviewMessageProps {
  preview: ReportPreviewClient;
}

export function OutdatedPreviewMessage({
  preview,
}: OutdatedPreviewMessageProps) {
  return (
    <Wrapper>
      <WarningAlert>
        <p>Skademeldingen har blitt oppdatert siden forhåndsvisningen ble hentet.</p>
        <ButtonLink
          variant="secondary"
          isLoading={preview.isLoading}
          onClick={() => preview.fetch()}
        >
          Hent på nytt
        </ButtonLink>
      </WarningAlert>
    </Wrapper>
  );
}
